import loadable from "@loadable/component";

export const AddEditUserForm = loadable(() =>
  import("./EditUserForm/index.form"),
);
